import React from 'react'
import ClassNames from 'classnames'
import { AccordionListStyle } from './styled'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import { ICONS, ICONS_LINK } from '../../themes'

/**
 * Button description
 * - ...
 */

export class AccordionList extends React.PureComponent {
  render() {
    const {
      className,
      children,
      title,
      id,
      disabled,
      isDisable,
      style,
    } = this.props
    const img = (
      // <img src="https://buyer.dev.srm.tspace.astrosystem.co/static/media/icon-arrow-down.198f2e08.svg" />
      // <img src={ICONS_LINK('/static/media/icon-arrow-down.198f2e08.svg')} />
      <img src={ICONS['icon-arrow-down.svg']} alt={title} />
    )
    return (
      <AccordionListStyle
        className={ClassNames(
          'accordion-list',
          { 'is-disabled': disabled || isDisable },
          className
        )}
        id={id}
        style={style}
        // title={title}
      >
        <Accordion>
          <AccordionSummary
            className="accordion-summary"
            expandIcon={img}
            id={id}
          >
            {title}
          </AccordionSummary>
          <AccordionDetails className="accordion-details">
            {children}
          </AccordionDetails>
        </Accordion>
      </AccordionListStyle>
    )
  }
}
